import { FC } from "react";
import { WidgetSetupSubHeader } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/WidgetSetupSubHeader";
import { useAppSelector } from "@/store/hooks";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";
import { widgetViewNameByViewIdIdSelector } from "@/store/dashboards/selectors/widgets/common/widgetViewNameByViewIdIdSelector";
import { billingExplorerWidgetSetupBillingExportUrlSelector } from "@/store/dashboards/selectors/setups/billing-explorer/billingExplorerWidgetSetupBillingExportUrlSelector";

export const NormalizedCostWidgetSetupSubHeader: FC = () => {
  const setup = useAppSelector(normalizedCostWidgetSetupSelector);
  const viewName = useAppSelector((state) =>
    widgetViewNameByViewIdIdSelector(state, setup?.viewId),
  );
  const billingExplorerUrl = useAppSelector(
    billingExplorerWidgetSetupBillingExportUrlSelector,
  );

  return (
    <WidgetSetupSubHeader
      name={setup?.name ?? ""}
      dates={setup?.dates ?? {}}
      title={viewName ?? ""}
      url={billingExplorerUrl}
    />
  );
};
